var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 9",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4243 4.92426C24.6586 4.68995 24.6586 4.31005 24.4243 4.07573L20.6059 0.257357C20.3716 0.0230428 19.9917 0.0230428 19.7574 0.257357C19.523 0.491672 19.523 0.871571 19.7574 1.10589L23.1515 4.5L19.7574 7.89411C19.523 8.12843 19.523 8.50832 19.7574 8.74264C19.9917 8.97695 20.3716 8.97695 20.6059 8.74264L24.4243 4.92426ZM5.24537e-08 5.1L24 5.1L24 3.9L-5.24537e-08 3.9L5.24537e-08 5.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.b7eb0451ed4181dcfaee6a0443274afd.svg";
export { ForwardRef as ReactComponent };